import "../../assets/styles/style_pgi.scss";
import React, { useEffect, useState, useRef } from "react";
import useMaps from "../../hooks/useMaps";
import Table from "../../components/pgi/Table";
import useCorralonFilter from "../../hooks/useCorralonesFilter";
import { toast } from "react-hot-toast";

const CorralonesPgi = () => {
  const [filterText, setFilterText] = useState(null);
  const selectCorralon = useRef([]);

  const { corralonesAll } = useMaps();
  const { corralonesFilter, createCorralonFilter, editCorralonFilter } =
    useCorralonFilter();

  const filteredItems = corralonesAll?.filter(
    (item) =>
      // eslint-disable-next-line no-mixed-operators
      (item?.nombre &&
        // eslint-disable-next-line no-mixed-operators
        item?.nombre.toLowerCase().includes(filterText?.toLowerCase())) ||
      item?.email.toLowerCase().includes(filterText?.toLowerCase())
  );

  const columnsTable = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "50px",
    },
    {
      name: "Nombre",
      selector: (row) => row.nombre,
      sortable: true,
      minWidth: "100px",
    },
    {
      name: "Dirección",
      selector: (row) => row.direccion,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      minWidth: "100px",
    },
  ];

  let newArray = [];

  if (corralonesAll && Array.isArray(corralonesAll)) {
    if (corralonesFilter && Array.isArray(corralonesFilter[0]?.corralones)) {
      newArray = corralonesAll.filter(
        (corralon) =>
          !corralonesFilter[0].corralones?.some((c) => c.id === corralon.id)
      );
    }
  }

  const handleChange = ({ selectedRows }) => {
    // You can set state or dispatch with something like Redux so we can use the retrieved data
    selectCorralon.current = selectedRows;
  };

  const saveCorralon = () => {
    try {
      editCorralonFilter({
        corralones: selectCorralon.current,
        _id: "63c6f1ae8580ff4a22fa2781",
        id: 2,
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.error("Error al actualizar la sección");
    }
  };

  const downloadCSV = (data, filename) => {
    const csv = convertToCSV(data);
    const csvData = new Blob([csv], { type: "text/csv" });

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(csvData, filename);
    } else {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(csvData);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  function convertToCSV(data) {
    const header = "corralon_id,nombre,direccion,telefono,email";
    const rows = data.map(
      (obj) =>
        `${obj.corralon_id},${obj.nombre},${obj.direccion},${obj.telefono},${obj.email}`
    );
    return `${header}\n${rows.join("\n")}`;
  }

  const exportToCSV = () => {
    downloadCSV(corralonesAll, "Corralones.csv");
  };

  const exportCheckToCSV = () => {
    downloadCSV(newArray, "CorralonesHabilitados.csv");
  };

  return (
    <section className="p-5 my-5 container containerPgi">
      <div className="d-md-flex justify-content-between container">
        <h2>Corralones</h2>

        <div className="container-filter mt-2">
          <input
            onChange={(e) => setFilterText(e.target.value)}
            className="form-control input-filter"
            type="serch"
          />
          <button className="button-corralon-pgi" type="button">
            <span>Buscar</span>
          </button>
        </div>
      </div>

      <Table
        className={"marmoleria--datatable"}
        selectRows={true}
        columnsTable={columnsTable}
        filteredData={filteredItems?.length > 0 ? filteredItems : corralonesAll}
        expandedRow={false}
        handleChange={handleChange}
        corralonesFilter={corralonesFilter}
      />
      <div className="d-flex justify-content-between">
        <button
          className="button-corralon-pgi"
          type="button"
          onClick={saveCorralon}
        >
          <span>Guardar</span>
        </button>
        <div className="d-flex align-items-center">
          <h4>Descarga masiva:</h4>
          <button
            className="button-corralon-pgi"
            type="button"
            onClick={exportToCSV}
          >
            <span>Todos</span>
          </button>
          <button
            className="button-corralon-pgi"
            type="button"
            onClick={exportCheckToCSV}
          >
            <span>Habilitados</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default CorralonesPgi;
